<template>
  <div class="p-4 bg-white rounded-lg h-100" v-if="isDataLoaded">
    <DataTable
      :table_state="table_state"
      :store_names="store_names"
      :addComponent="componentForAdding"
      :editComponent="componentForEditing"
      :actionsComponent="componentForActions"
      :uploadDocComponent="componentForUploadDoc"
      :showDetailComponent="componentForDetails"
      :addCommentComponent="componentForAddComment"
      :delete_url="delete_url"
      :urls="urls"
    >
    </DataTable>
  </div>
</template>

<script>
import DataTable from "@/own/components/DataTable.vue";
import AddItem from "@/own/components/warehouseManagement/exception/AddItem.vue";
import AddComment from "@/own/components/warehouseManagement/exception/AddComment.vue";
import EditItem from "@/own/components/warehouseManagement/exception/EditItem.vue";
import ShowDetails from "@/own/components/warehouseManagement/exception/ShowDetails.vue";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import {
  EXPORT_TABLE_DATA,
  SET_TABLE_FILTER,
  SET_TABLE_PAGE,
  SET_TABLE_PERPAGE,
  SET_TABLE_SORTBY,
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_STRUCTURE,
} from "@/core/services/store/exceptions.module";
import DataTableActionSelectorNew from "@/own/components/DataTableActionSelectorNew.vue";
import QueueUploadModal from "@/own/components/Modals/QueueUploadModal";
export default {
  name: "Exceptions",
  components: { DataTable },
  data: () => ({
    componentForEditing: EditItem,
    componentForAdding: AddItem,
    componentForActions: DataTableActionSelectorNew,
    componentForUploadDoc: QueueUploadModal,
    componentForDetails: ShowDetails,
    componentForAddComment: AddComment,
    delete_url: `${process.env.VUE_APP_BASE_URL}/warehouse_management/warehouse_exceptions/destroy`,
    table_state: {
      UPDATE_TABLE_STRUCTURE: UPDATE_TABLE_STRUCTURE,
      UPDATE_TABLE_DATA: UPDATE_TABLE_DATA,
      SET_TABLE_SORTBY: SET_TABLE_SORTBY,
      SET_TABLE_FILTER: SET_TABLE_FILTER,
      SET_TABLE_PERPAGE: SET_TABLE_PERPAGE,
      SET_TABLE_PAGE: SET_TABLE_PAGE,
      EXPORT_TABLE_DATA: EXPORT_TABLE_DATA,
    },
    store_names: {
      getTableFilters: "getEXCEPTIONTableFilters",
      getTableState: "getEXCEPTIONTableState",
      getTableData: "getEXCEPTIONTableData",
      getTableHeaders: "getEXCEPTIONTableHeaders",
      getTableProperties: "getEXCEPTIONTableProperties",
      getTableExportUrl: "getEXCEPTIONExportUrl",
      getTablePermissions: "getEXCEPTIONTablePermissions",
      getUploadType: "getEXCEPTIONUploadType",
    },
    urls: {
      delete: `${process.env.VUE_APP_BASE_URL}/warehouse_management/warehouse_exceptions/delete`,
      status: `${process.env.VUE_APP_BASE_URL}/warehouse_management/warehouse_exceptions/status`,
      uploadDoc: `/warehouse_management/warehouse_exceptions/upload-doc`,
    },
  }),
  methods: {
    async initTableContent() {
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_STRUCTURE, {});
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_DATA, {});
    },
  },
  computed: {
    isDataLoaded: function () {
      return this.$store.getters[this.store_names.getTableData];
    },
  },
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.initTableContent();
  },
};
</script>
